import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-442a3946"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "layout_top" }
const _hoisted_3 = { class: "layoutBox" }
const _hoisted_4 = { class: "logoLine" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout_top_title" }, "请阅读为您准备的手册", -1))
const _hoisted_7 = { class: "searchBox" }
const _hoisted_8 = { class: "main layoutBox" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout_bottom" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "选择广东奥新智创，让流程更便捷"),
  /*#__PURE__*/_createElementVNode("div", { class: "copyrightBox" }, "Copyright@2023 广东奥新智创技术有限公司 All Rights Reserved. 粤ICP备16010349号")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search = _resolveComponent("search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_backtop = _resolveComponent("el-backtop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_ctx.decryptData.name) + "-帮助中心", 1)
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.keyWord,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyWord) = $event)),
            placeholder: "搜索",
            clearable: "",
            onKeyup: _withKeys(_ctx.onSearchBox, ["enter"])
          }, {
            prefix: _withCtx(() => [
              _createVNode(_component_el_icon, { class: "el-input__icon" }, {
                default: _withCtx(() => [
                  _createVNode(_component_search)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onKeyup"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "main",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _hoisted_9,
    _createVNode(_component_el_backtop, {
      right: 20,
      bottom: 20,
      title: "回到顶部"
    })
  ]))
}